<template>
  <div class="chat-page">
    <!-- 展开按钮 - 在聊天列表收起时显示 -->
    <div v-if="isChatListCollapsed" class="expand-button" @click="handlePanelToggle">
      <span class="menu-icon">☰</span>
    </div>
    <div class="chat-list" :class="{ collapsed: isChatListCollapsed }">
      <ChatList ref="chatList" @showBimPlanet="showBimPlanet"></ChatList>
    </div>
    <div v-if="!ifshowChatPage" class="bim-planet-dashboard">
      <BIMPlanet @switchChatpage="switch_Chatpage"></BIMPlanet>
    </div>
    <div class="chat-container" v-show="ifshowChatPage">
      <div class="chat-header">
        <div v-show="isChatListCollapsed" class="scene">
          {{ currentScene }}
        </div>
      </div>
      <!-- Right side: Chat interface -->
      <div class="chat-messages" ref="chatMessages">
        <div v-for="(item, index) in chatRecords" :key="index" :class="item.sender">
          <div class="icon">
            <img v-if="item.sender === 'user'" src="../../assets/images/userIcon.png" alt="用户头像" />
            <img v-else :src=robotIcon alt="AI头像" />
          </div>
          <div class="message-container">
            <div v-if="item.sender === 'ai' && extractThinkContent(item.content)" class="think">
              <div class="title">
                <p>思考内容</p>
                <button @click="ifshowThoughts = !ifshowThoughts" :style="ifshowThoughts ? hideIcon : showIcon"></button>
              </div>
              <div v-show="ifshowThoughts" class="message" style="background-color:rgb(231, 231, 231);"
                v-html="formatMath(extractThinkContent((item.content)))">
              </div>
            </div>

            <div class="message" v-html="formatMath(removeThinkContent(item.content))"> </div>
            <!-- 添加复制，更新，点赞和反对按钮 -->
            <div v-if="item.sender === 'ai'" class="extra-panel">
              <img src="../../assets/images/copyMessage.png" @click="copyMessage(item)">
              <img src="../../assets/images/tryAgain.png" @click="resendMessage(index)">
              <img :src="thumbUp(item.vote)" @click="voteup(item)">
              <img :src="thumbDown(item.vote)" @click="votedown(item)">
            </div>
          </div>
        </div>
        <!-- <div v-show="waitingForResponse" class="ai">
          <div class="icon">
            <img src="../../assets/images/robot.png" alt="AI头像" />
          </div>
          <div class="message" style="padding-left: 30px;">AI正在生成回答...</div>
          <div class="waiting">
            <img src="../../assets/images/waitingIcon.png" alt="等待AI回复" />
          </div>
        </div> -->
        <!-- Display user and AI chat records -->
      </div>
      <div class="chat-input">
        <!-- User input box -->
        <textarea v-model="message" placeholder="输入您想问的问题" @keydown="handleKeydown"></textarea>
        <div class="buttons">
          <img v-show="false" @click="addFile" src="../../assets/images/attach-file.png" alt="附加文件" />
          <img v-show="!waitingForResponse" @click="sendUserMessage(message)" src="../../assets/images/sendMessage.png" alt="发送" />
          <img v-show="waitingForResponse" src="../../assets/images/sendMessage_disabled.png" alt="发送" />
        </div>
        <div class="chat-config" style="position:absolute;margin-top: 130px;">
          <el-switch v-model="ifUseKnowldgeBase" active-color="#13ce66" inactive-color="#ff4949" inactive-text="使用知识库"
            style="margin-right: 10px;">
          </el-switch>
          <el-switch v-model="ifUseWeb" active-color="#13ce66" inactive-color="#ff4949" inactive-text="联网搜索">
          </el-switch>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import { askOpenAI} from '@/api/ai_chat';
import ChatList from '../components/ChatList.vue';
import { sendMessage, getChatHistory, createChat, updateVote, getAgentResponse, getAgentResponseStream } from '@/api/auth';
import { tokenMixin } from '@/mixins/tokenMixin';
import { marked } from 'marked';
import showIconImage from '../../assets/images/show-icon.png';
import hideIconImage from '../../assets/images/hide-icon.png';
import BIMPlanet from './BIMPlanet.vue';
//import MathJax from 'mathjax';

export default {
  name: 'ChatPage',
  mixins: [tokenMixin],
  components: {
    ChatList,
    BIMPlanet
  },
  data() {
    return {
      message: '', // User input message
      chatRecords: [], // Array to store chat records
      waitingForResponse: false, // Flag to indicate if waiting for AI response
      ai_response: '',//AI回复
      ifPushed: false,//AI回复是否已经推送
      usertimestamp: '',//用户发送消息的时间戳
      aitimestamp: '',//AI回复的时间戳
      ifNewChat: false,//是否新建聊天
      showIcon: { backgroundImage: `url(${showIconImage})` },
      hideIcon: { backgroundImage: `url(${hideIconImage})` },
      ifshowThoughts: false,//是否显示思考内容
      ifUseKnowldgeBase: true,//是否使用知识库
      ifUseWeb: true,//是否联网搜索
      ifshowChatPage: true,
      currentScene: 'chat', // 当前场景，默认为聊天
      robotIcon: require('../../assets/images/robot.png'), // AI头像
      greetingMessage: '欢迎来到中建八局AI智能体中心~' + '\n' + '很高兴遇到你，关于BIM建模、政策热点、投标文本的问题都可以问我~', // 问候语
      currentBalance: 0, // 当前用户余额
    };
  },
  computed: {
    currentUserId() {
      return this.$store.state.userId;
    },
    isChatListCollapsed: {
      get() {
        return this.$store.state.isChatListCollapsed;
      },
      set(value) {
        this.$store.commit('setChatListCollapsed', value);
      }
    }
  },
  mounted() {
    // Fetch chat records from API
    // if(this.$store.state.currentChatId){
    //     getChatHistory(this.$store.state.currentChatId).then((response) => {
    //         console.log('获取聊天记录',response);
    //         this.chatRecords = response;
    //     });
    // }
    // Check if there is a message in the URL query
    if (this.$route.query.message) {
      this.message = this.$route.query.message;
      this.sendUserMessage(this.message);
    }
    // Fetch chat records from API
    if (this.chatRecords.length === 0) {
      // Add initial chat records
      this.pushGreeting();
    }
    // 动态加载 MathJax CDN
    this.loadMathJax().then(() => {
      this.renderMath();
    });
    
    // 获取用户余额
    if (this.currentUserId) {
      this.refreshBalance();
    }

    // 监听窗口大小变化
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  },

  beforeDestroy() {
    // 清理窗口大小监听器
    window.removeEventListener('resize', this.handleResize);
  },

  methods: {
    // 监听窗口大小变化
    handleResize() {
      if (window.innerWidth < 768) {
        this.isChatListCollapsed = true;
      } else {
        // 大屏幕时默认显示聊天列表
        this.isChatListCollapsed = false;
      }
    },
    
    // 处理聊天列表面板切换
    handlePanelToggle() {
      this.isChatListCollapsed = !this.isChatListCollapsed;
    },
    
    // 刷新用户余额
    async refreshBalance() {
      this.currentBalance = await this.getCurrentBalance();
    },
    
    // 前往充值页面
    goToRecharge() {
      this.$router.push('/balance');
    },
    
    // 余额更新回调
    onBalanceUpdated(newBalance) {
      this.currentBalance = newBalance;
    },
    
    switch_Chatpage(title)
    {
      // 切换到聊天页面
      this.switchScene(title)
      this.ifshowChatPage = true;
      this.currentScene = title;
      const date = new Date();
      const chatTitle = title + date.getFullYear() + date.getMonth() + date.getDay() + date.getHours() + date.getMinutes() + date.getSeconds();
      createChat(this.$store.state.userId, chatTitle,title).then((response) => {
            // Logic for creating a new chat
            this.$refs.chatList.getUserChatList();//更新左侧列表
            this.$store.commit('setCurrentChatId', response.chat_id);  // 更新当前聊天id        
            console.log('新建聊天', response);
            this.ifNewChat = true;
          });
    },
    switchScene(scene) {
      // 切换场景
      switch (scene) {
        case 'BIM建模助手':
          this.robotIcon = require('../../assets/images/bim-planet/BIM建模助手图标.png');
          this.greetingMessage='欢迎来到BIM建模助手，您的专属BIM软件操作顾问！无论您是建模新手还是资深专家，我们都将提供详尽的操作流程、实用的技巧建议，助您轻松驾驭BIM软件，让建模工作更加高效、精准。让我们一起开启创意无限的BIM建模之旅吧！🏗️🤖📈'
          //console.log(this.greetingMessage);
          break;
        case 'BIM政策热点':
          this.robotIcon = require('../../assets/images/bim-planet/BIM政策分析.png');
          this.greetingMessage='欢迎来到BIM政策热点助手，您的政策解读专家！我们将为您提供最新的BIM政策动态、深入的解读分析和实用的应用建议，助您在复杂的政策环境中游刃有余。让我们一起探索BIM政策的前沿与未来吧！📜🤖💡'
          break;
        case 'BIM投标助手':
          this.robotIcon = require('../../assets/images/bim-planet/AI标书.png');
          this.greetingMessage='欢迎来到BIM投标助手，您的投标文本生成专家！我们将为您提供高效的投标文本生成、精准的政策解读和实用的建模建议，助您在投标过程中游刃有余。让我们一起开启高效投标之旅吧！📄🤖💼';
          break;
        case 'BIM审查':
          this.robotIcon = require('../../assets/images/bim-planet/BIM审核图片.jpg');
          this.greetingMessage='欢迎来到BIM审查助手，您的建模质量守护者！只需上传您的BIM模型截图，我将运用先进的AI技术为您深入分析，快速识别潜在的建模问题，提供专业的改进建议。📄🤖💼';
          break;
        case 'BIM解决方案':
          this.robotIcon = require('../../assets/images/bim-planet/AI专家.png');
          this.greetingMessage='欢迎来到BIM解决方案专家，您的建筑数字化转型顾问！在这里，我们提供全方位的解决方案，涵盖数字孪生、智慧城市、智慧园区等领域。无论您是寻求提升项目效率、优化资产管理，还是构建未来城市蓝图，我们都能助您一臂之力。让我们共同探索建筑数字化的无限可能，打造更加智能、可持续的生活环境！🏙️🌐🤖';
          break;
        case 'AI找图':
          this.robotIcon = require('../../assets/images/bim-planet/AI找图.png');
          this.greetingMessage='欢迎来到AI找图助手，您的智能视觉搜索伙伴！只需告诉我您心中的画面，无论是抽象的概念还是具体的场景，我都能通过强大的AI算法，为您快速找到最匹配的图片。让我们告别大海捞针，一起轻松探索视觉世界的无限精彩吧！🔎🖼️🧠';
          break;
        default:
          this.robotIcon = require('../../assets/images/robot.png');
          this.greetingMessage= '欢迎来到中建八局AI智能体中心AILab~' + '\n' + '很高兴遇到你，关于BIM建模、政策热点、投标文本的问题都可以问我~';
      }
    },

    showBimPlanet(ifshow) {
      this.ifshowChatPage = !ifshow;
    },
    async fetchAgentResponse(message, chat_history, user_id, ifUseKnowldgeBase, ifUseWeb,systemPrompt) {
      try {
        let answer= '';
        this.aitimestamp = new Date().getTime();
        
        const response = await getAgentResponseStream(message, chat_history, user_id, ifUseKnowldgeBase, ifUseWeb,systemPrompt);
        
        this.chatRecords.push({
              sender: 'ai',
              content: '',
              timestamp: this.aitimestamp,
            });
        if (!response || !response.body) {
          throw new Error('Response body is not available');
        }
        const reader = response.body.getReader();
        const decoder = new TextDecoder('utf-8');
        let done = false;
        while (!done) {
          const { done, value } = await reader.read();
          if (done) break;
          if (value) {
            //console.log('Received chunk:', decoder.decode(value));
            const chunk = decoder.decode(value);
            console.log('Received chunk:', decoder.decode(value));
            //this.message = this.message + chunk; // Append the chunk to the message
            this.chatRecords[this.chatRecords.length - 1].content += chunk; // Append the chunk to the last AI message
            answer += chunk; // Append the chunk to the answer
            //return chunk;
            // 处理接收到的分块数据
            // 例如，将其添加到一个数组中，或者直接输出到控制台
          }

        }
        return answer;

      }
      catch (error) {
        console.error('Error fetching agent response:', error);
        return { response: 'Error fetching response' };
      }


    },
    extractThinkContent(text) {
      const regex = /<think>(.*?)<\/think>/gs;
      const match = regex.exec(text)
      if (match) {
        return match[1];
      }
      else {
        return '';
      }
    },
    removeThinkContent(text) {
      return text.replace(/<think>.*?<\/think>/gs, '');
    },
    pushGreeting() {
      this.chatRecords.push({
        sender: 'greeting',
        content: this.greetingMessage,
      });
    },
    thumbUp(vote) {
      if (vote == undefined) return require("../../assets/images/approve.png");

      if (vote <= 0)
        return require("../../assets/images/approve.png");
      else
        return require("../../assets/images/approve_selected.png");
    },
    thumbDown(vote) {
      if (vote == undefined) return require("../../assets/images/disapprove.png");
      if (vote >= 0)

        return require("../../assets/images/disapprove.png");
      else
        return require("../../assets/images/disapprove_selected.png");
    },
    voteup(item) {
      const timestamp = item.timestamp;
      item.vote = 1;
      // Handle upvoting logic
      updateVote(this.$store.state.userId, this.$store.state.currentChatId, timestamp, 1).then((response) => {
        console.log(response);
      });
      console.log('投票成功', timestamp);
    },
    votedown(item) {
      // Handle downvoting logic
      const timestamp = item.timestamp;
      item.vote = -1;
      updateVote(this.$store.state.userId, this.$store.state.currentChatId, timestamp, -1).then((response) => {
        console.log(response);
      });
      console.log('投票成功', timestamp);
    },
    resendMessage(index) { //重新发送消息
      // Handle resending message logic
      this.sendUserMessage(this.chatRecords[index - 1].content);
    },
    copyMessage(content) {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(content.content).then(function () {
          console.log('Text copied to clipboard');
          alert('文本已复制');
        }, function (err) {
          console.error('Failed to copy text: ', err);
        });
      } else {
        console.log('Clipboard API not available');
      }
    },
    formatMath(text) {//格式化数学公式
      if (!text) return '';
      const htmlContent = marked(text); // 使用 marked 解析 Markdown
      if (text.includes("\\[")) {
        // 如果包含块级公式标记，则直接渲染为块级
        return `<div>${text}</div>`;
      } else {

        // 否则，渲染为行内公式
        return `<span>${htmlContent}</span>`;
      }
    },
    loadMathJax() {
      return new Promise((resolve) => {
        if (window.MathJax) {
          resolve(); // 如果 MathJax 已经加载，直接返回
        } else {
          const script = document.createElement('script');
          script.src = 'https://cdn.staticfile.org/mathjax/3.2.2/es5/tex-mml-chtml.js'

          script.async = true;
          script.onload = resolve;
          document.head.appendChild(script);
        }
      });
    },
    //再帮我引用一下markdown的库

    renderMath() {
      // 渲染页面中的数学公式
      if (window.MathJax) {
        window.MathJax.typeset();
      }
    },
    scrollToBottom() {
      const container = this.$refs.chatMessages;
      container.scrollTop = container.scrollHeight;
    },
    async sendUserMessage(message) {
      // Handle sending message logic
      if (message != '') {
        // 先检查余额是否充足（预估最小tokens）
        const minEstimatedTokens = message.length; // 最小预估：至少用户消息的字符数
        console.log(`预估最少消耗 ${minEstimatedTokens} tokens`);
        
        // 检查余额
        const hasBalance = await this.checkTokenBalance(minEstimatedTokens);
        if (!hasBalance) {
          return; // 余额不足，停止发送
        }
        
        console.log(this.$store.state.userId,
          this.$store.state.currentChatId,
          message);
        // Add user message to chat records
        //如果没有当前聊天id，新建聊天
        if (!this.$store.state.currentChatId) {
          const date = new Date();
          const chatTitle = '新聊天' + date.getFullYear() + date.getMonth() + date.getDay() + date.getHours() + date.getMinutes() + date.getSeconds();
          createChat(this.$store.state.userId, chatTitle,this.currentScene).then((response) => {
            // Logic for creating a new chat
            this.$refs.chatList.getUserChatList();//更新左侧列表
            this.$store.commit('setCurrentChatId', response.chat_id);  // 更新当前聊天id        
            console.log('新建聊天', response);
            this.ifNewChat = true;
          });
        }
        else {
          
          this.usertimestamp = new Date().getTime();
          this.chatRecords.push({
            sender: 'user',
            content: message,
            timestamp: this.usertimestamp
          });
          this.message = '';
          this.waitingForResponse = true;
          
          this.fetchAgentResponse(message, this.chatRecords, this.$store.state.userId, this.ifUseKnowldgeBase, this.ifUseWeb,this.greetingMessage).then(async (res) => {
            // AI回复完成后，根据实际消耗进行tokens扣除
            const totalTokens = message.length + (res ? res.length : 0);
            const messagePreview = message.length > 30 ? message.substring(0, 30) + '...' : message;
            
            console.log(`实际消耗tokens: 用户消息${message.length}字符 + AI回复${res ? res.length : 0}字符 = ${totalTokens}字符`);
            
            // 扣除实际消耗的tokens
            const deductResult = await this.deductTokens('ai_chat', `AI对话：${messagePreview}`, { 
              userMessageLength: message.length,
              aiResponseLength: res ? res.length : 0,
              totalTokens: totalTokens
            });
            
            if (!deductResult) {
              // 如果扣费失败，显示错误但不影响已经生成的回复
              this.$message.warning('Tokens扣除失败，请检查余额');
            }
            
            await sendMessage(
              this.$store.state.userId,
              this.$store.state.currentChatId,
              message,
              res,
              this.usertimestamp,
              this.aitimestamp,
              0//投票数
            );
            this.waitingForResponse = false;  // 停止等待
            this.renderMath();
            this.scrollToBottom();
            
            // 更新余额显示
            this.refreshBalance();
            
            console.log('当前聊天记录长度', this.chatRecords.length);
            if (this.chatRecords.length == 3) {
              await getAgentResponse('请根据聊天记录总结本次聊天标题，不超过10个字', this.chatRecords,this.$store.state.userId,false,false).then((res1) => {
                this.$refs.chatList.updateUserChatTitle(this.$store.state.userId, this.$store.state.currentChatId, res1.response);
              });
            }
          }).catch(async (error) => {
            this.waitingForResponse = false;
            
            // AI回复失败时，只扣除用户消息的tokens
            const userTokens = message.length;
            const messagePreview = message.length > 30 ? message.substring(0, 30) + '...' : message;
            
            console.log(`AI回复失败，扣除用户消息tokens: ${userTokens}字符`);
            
            const deductResult = await this.deductTokens('ai_chat', `AI对话(失败)：${messagePreview}`, { 
              userMessageLength: message.length,
              aiResponseLength: 0,
              totalTokens: userTokens
            });
            
            if (deductResult) {
              this.$message.error('AI回复失败，已扣除用户消息对应的tokens');
            } else {
              this.$message.error('AI回复失败，tokens扣除也失败');
            }
            
            // 更新余额显示
            this.refreshBalance();
            
            console.error('AI回复失败:', error);
          });
        }
      }
    },

    //按下Enter键发送消息
    handleKeydown(event) {
      if (event.key === 'Enter') {
        // 检查是否同时按下了Ctrl键
        if (event.ctrlKey) {
          // Ctrl+Enter，插入换行
          event.preventDefault(); // 阻止默认行为
          this.message += '\n';

        } else {
          // 仅Enter，发送消息
          event.preventDefault(); // 阻止默认行为
          //this.fetchAgentResponse(this.message, this.chatRecords, this.$store.state.userId,this.ifUseKnowldgeBase,this.ifUseWeb);
          this.sendUserMessage(this.message);


        }
      }
    },
    addFile() {
      // Handle adding file logic
    }
  },
  watch: {


    chatRecords(newVal) {//监听chatRecords的变化
      this.$nextTick(() => {
        this.scrollToBottom();
        this.renderMath();
      });
      if (newVal.length == 0) {
        this.pushGreeting();
      }

    },
    '$store.state.currentChatId': function () {
      console.log('currentChatId变化了', this.$store.state.currentChatId);
      getChatHistory(this.$store.state.userId, this.$store.state.currentChatId).then((response) => {
        console.log('获取聊天记录', response);
        this.chatRecords = response.messages || [];
        this.currentScene = response.scene;
        this.switchScene(this.currentScene);
        if (this.chatRecords.length == 0) {
          this.pushGreeting();
          if (this.ifNewChat) {
            this.sendUserMessage(this.message);
            this.ifNewChat = false;
          }
        }
      });
    }
  }
};
</script>

<style scoped>
.scene{
  margin-top: 20px;
  margin-left: 20px;
  font-family: pingfang SC;
  font-size: 28px;
  font-weight: 600;
}
.chat-page {
  position: fixed;
  display: flex;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #F4F7FF;
}

.chat-list {
  width: 300px;
  height: 100vh;
  position: relative;
  transition: width 0.3s ease;
  /* Add styling for chat list */
}

.chat-list.collapsed {
  width: 0px !important;
  min-width: 0px !important;
  max-width: 0px !important;
  height: 100vh;
  position: relative;
  overflow: hidden;
  opacity: 0;
  pointer-events: none;
}

.expand-button {
  position: fixed;
  top: 60px;
  left: 10px;
  width: 40px;
  height: 40px;
  background: white;
  border-radius: 50%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 1000;
  transition: all 0.3s ease;
}

.expand-button:hover {
  background: #f5f5f5;
  transform: scale(1.1);
}

.expand-button .menu-icon {
  font-size: 20px;
  color: #333;
  line-height: 1;
}

.expand-button img {
  width: 20px;
  height: 20px;
}

.extra-panel {
  margin-left: 10px;
  margin-top: 10px;

  img {
    width: 20px;
    height: 20px;
    cursor: pointer;
    margin-right: 10px;
  }
}

.chat-container {
  flex: 3;

  display: flex;
  flex-direction: column;
  background: white;
  border-radius: 20px;
}

.chat-header {
  display: flex;
  justify-content: space-between;
  height: 60px;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid #c2c3c5;
  background: white;
  border-radius: 20px 20px 0 0;
}

.scene {
  font-size: 18px;
  font-weight: bold;
  color: #333;
}



.recharge-mini-btn {
  background: rgba(255, 255, 255, 0.2) !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  color: white !important;
  font-size: 12px;
  padding: 4px 12px !important;
  height: auto;
}

.recharge-mini-btn:hover {
  background: rgba(255, 255, 255, 0.3) !important;
  border-color: rgba(255, 255, 255, 0.5) !important;
}

.bim-planet-dashboard {
  flex: 3;
  display: flex;
  flex-direction: column;
  background: white;
  border-radius: 20px;
}

.chat-messages::-webkit-scrollbar {
  width: 8px;
}

.chat-messages::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.chat-messages::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}

.chat-messages::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.message-container {
  display: flex;
  flex-direction: column;
}

.chat-messages {
  flex: 1;                    /* 占据剩余空间 */
  padding: 20px;             /* 内边距 */
  overflow-y: auto;          /* 垂直滚动 */
  margin-bottom: 10px;       /* 底部间距 */

  /* Add vertical scrollbar */
  .message {
    white-space: pre-wrap;
    /* 保留换行符并自动换行 */
    word-wrap: break-word;
    /* 长单词换行 */
  }

  /* 自定义滚动条样式 */

  /* Add styling for chat messages */
  .user {
    display: flex;
    flex-direction: row-reverse;
    margin-top: 10px;
    margin-right: 10px;

    .message {
      background-color: #0B48EA;
      padding: 10px;
      justify-content: flex-end;
      border-radius: 10px;
      color: white;
    }

    .icon {
      img {
        width: 32px;
        height: 32px;

      }

    }
  }

  .ai,
  .greeting {
    display: flex;
    margin-top: 10px;
    margin-left: 0px;

    .message {
      display: flex;
      padding: 10px;
      justify-content: flex-start;
      margin-top: 10px;
      margin-left: 10px;
      border-radius: 10px;
    }

    .icon {
      img {
        margin-top: 10px;
        width: 32px;
        height: 32px;
        border-radius: 16px;
      }
    }

    .waiting {
      position: absolute;
      align-items: center;
      margin-top: 20px;
      margin-left: 50px;

      img {
        width: 16px;
        height: 16px;
        -webkit-animation: rotate 1s linear infinite;
        animation: rotate 1s linear infinite;
      }
    }

    @-webkit-keyframes rotate {
      0% {
        transform: rotate(0deg);
      }

      100% {
        transform: rotate(360deg);
      }
    }
  }


}

.chat-input {
  display: flex;
  flex-direction: column;
  margin: 20px 20px 20px 20px;
  min-height: 120px;
  border-radius: 10px;
  padding: 10px;
  box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
  background: white;
  flex-shrink: 0;

  /* Add styling for chat input box */
  textarea {
    outline: none;
    padding: 10px;
    /* width: 780px; */
    height: 90px;
    border-radius: 10px;
    border-width: 0;
    resize: none;
    font-size: 16px;
    font-family: pingFangSC;
  }

  /* 自定义滚动条样式 */
  textarea::-webkit-scrollbar {
    width: 8px;
  }

  textarea::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
  }

  textarea::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 10px;
  }

  textarea::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

  .buttons {
    display: flex;
    position: absolute;
    width: 55px;
    height: 24px;
    background-color: rgba(255, 255, 255, 0);
    right: 30px;
    bottom: 30px;

    img {
      cursor: pointer;
      width: 24px;
      height: 24px;
      border: 0;
      margin-right: 5px;
      margin-left: 0px;
    }

    img:hover {
      width: 26px;
      height: 26px;
    }
  }

}

.chat-input input {
  flex: 1;
  /* Add styling for input box */
}

.chat-input button {
  margin-left: 10px;
  /* Add styling for send button */
}

.title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  margin-left: 40px;
  font-family: pingfang SC;
  font-size: 28px;
  font-weight: 600;
}

.title p {
  font-size: 14px;
  font-family: pingfang SC;
}

.title button {
  width: 20px;
  height: 20px;
  background-size: 100% 100%;
  border: none;
  cursor: pointer;
}
</style>
